import sentryService from '@app/src/services/SentryService'

// MRT collection pages persist their view under keys shaped `<entity>-mrt.<slice>`
// (e.g. `providers-mrt.columnFilters`). Any new MRT config must keep the `-mrt` suffix
// on its storageKey to be cleared here.
export const MRT_STATE_SLICES = [
  'columnVisibility',
  'columnOrder',
  'columnFilters',
  'columnPinning',
  'sorting',
] as const

export const buildMrtStateKey = (storageKey: string, slice: (typeof MRT_STATE_SLICES)[number]) =>
  `${storageKey}.${slice}`

export const isMrtStateKey = (key: string): boolean => MRT_STATE_SLICES.some(slice => key.endsWith(`-mrt.${slice}`))

export const mrtStateKeysToRemove = (allKeys: string[]): string[] => allKeys.filter(isMrtStateKey)

// Runs inside the login/logout flows, so it must never throw: localStorage access can fail
// in privacy/blocked-storage modes. Fail open and report so auth is never broken by it.
export const clearPersistedMrtTableState = (): void => {
  try {
    const allKeys = Object.keys(window.localStorage)
    mrtStateKeysToRemove(allKeys).forEach(key => window.localStorage.removeItem(key))
  } catch (error) {
    sentryService.captureError(error as Error, {
      tags: {
        errorType: 'localStorage',
        operation: 'clear',
      },
    })
  }
}
